define('fukit/behavior/modal.save.button.behavior',['require','exports','module','underscore','marionette','backbone.radio','./hide.modal.on.event.behavior','./invoke.model.method.on.event.behavior','./enable.only.on.unsaved.changes.behavior','./show.modal.on.modal.hide.with.unsaved.changes.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                                              = require('underscore'),
      Mn                                             = require('marionette'),
      Radio                                          = require('backbone.radio'),
      HideModalOnEventBehavior                       = require('./hide.modal.on.event.behavior'),
      InvokeModelMethodOnEventBehavior               = require('./invoke.model.method.on.event.behavior'),
      EnableOnlyOnUnsavedChangesBehavior             = require('./enable.only.on.unsaved.changes.behavior'),
      ShowModalOnModalHideWithUnsavedChangesBehavior = require('./show.modal.on.modal.hide.with.unsaved.changes.behavior');

  var ModalSaveButtonBehavior = Mn.Behavior.extend({
    behaviors: function() {
      return {
        EnableOnlyOnUnsavedChangesBehavior: {
          behaviorClass: EnableOnlyOnUnsavedChangesBehavior,
        },
        TriggerConfirmSaveSuccessBehavior: {
          behaviorClass: Mn.Behavior.extend({
            onFirstRender: function() {
              this.listenTo(this.view, 'save:success', this.onEvent);
            },

            onEvent: function() {
              Mn.triggerMethodOn(Radio.request('modals', 'currentModal'), 'confirm');
            },
          }),
        },
        InvokeModelMethodOnEventBehavior: {
          method: 'save',
          onMethodSuccessEvent: 'save:success',
          showLoading: true,
          behaviorClass: InvokeModelMethodOnEventBehavior,
        },
        ShowModalOnModalHideWithUnsavedChangesBehavior: {
          behaviorClass: ShowModalOnModalHideWithUnsavedChangesBehavior,
        },
      };
    },
  });

  module.exports = ModalSaveButtonBehavior;
});

